import React from 'react';
import clsx from 'clsx';

import styles from './Preloader.module.css';

interface PreloaderProps {
  readonly fixed?: boolean;
  readonly text?: string;
}

export default ({ fixed, text = 'Loading…' }: PreloaderProps) => (
  <div
    className={clsx(styles.containerLoader, 'container-loader', {
      [styles.forceFixed]: fixed,
      'force-fixed': fixed,
    })}
    role="status"
    data-testid="interventionLoader"
  >
    <div className={clsx(styles.containerDash, 'container-dash')}>
      <div className={clsx(styles.dash, 'dash', styles.one, 'one')} />
      <div className={clsx(styles.dash, 'dash', styles.two, 'two')} />
      <div className={clsx(styles.dash, 'dash', styles.three, 'three')} />
      <div className={clsx(styles.dash, 'dash', styles.four, 'four')} />
    </div>
    <div className={clsx(styles.loadingText, 'loading-text')}>{text}</div>
  </div>
);
